import React from "react";
import styled from "styled-components";
import Icon from "react-crud-icons"
import { MdDelete } from "react-icons/md";


const AbstractSection = ({ formData, handleChange, hasAbstract, handleDeleteAbstract }) => {
    return (
        <Container>
            <div className="file-upload-section">
                <label htmlFor="abstract">Upload Abstract</label>
                <div className="file-input-container">
                    {formData.abstract ? (
                        <div className="file-selected">
                            <span className="file-name">{formData.abstract.name}</span>
                            <Delete>
                                <MdDelete 
                                    className="delete-btn" 
                                    size={18}
                                    onClick={handleDeleteAbstract}
                                />
                            </Delete>
                                
                            
                        </div>
                    ) : (
                        <>
                            <input 
                                type="file" 
                                id="abstract" 
                                name="abstract" 
                                onChange={handleChange}
                                accept=".pdf,.doc,.docx"
                                className="file-input"
                            />
                            <span className="file-format-note">Accepted formats: PDF, DOC, DOCX</span>
                        </>
                    )}
                </div>
            </div>

            {/* Symposium Type dropdown - only visible when abstract is uploaded */}
            {hasAbstract && (
                <SymposiumSection>
                    <div className="symposium-section">
                        <div className="form-row">
                            <div className="form-column">
                                <label htmlFor="symposium_type">Select Symposium Type*</label>
                                <select 
                                    id="symposium_type" 
                                    name="symposium_type" 
                                    value={formData.symposium_type} 
                                    onChange={handleChange}
                                    required={hasAbstract}
                                >
                                    <option value="" disabled>Choose the symposium your abstract will be submitted for</option>
                                    <option value="advanced_energy_materials">Advanced Energy Materials</option>
                                    <option value="advanced_functional_materials">Advanced Functional Materials</option>
                                    <option value="advanced_photonic_materials">Advanced Photonic Materials</option>
                                    <option value="advanced_electronic_materials">Advanced Electronic Materials</option>
                                    <option value="advanced_structural_materials">Advanced Structural Materials</option>
                                    <option value="advanced_biomaterials_for_healthcare">Advanced Biomaterials for Healthcare</option>
                                    <option value="advanced_nanoscience_and_nanotechnology">Advanced Nanoscience and Nanotechnology</option>
                                    <option value="advanced_geosciences_and_technology">Advanced Geosciences and Technology (Mining, Oil and Gas, Minerals extraction) </option>
                                    <option value="advanced_computational_artificial_intelligence_and_machine_learning">Advanced Computational, Artificial Intelligence and Machine Learning in Materials</option>
                                    <option value="Advanced_materials_for_water_and_environmental_remediation">Advanced Materials for Water and Environmental Remediation (Recycling and Green Technology)</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-column">
                            <label htmlFor="presentational_mode">Presentation Mode*</label>
                            <select 
                                id="presentational_mode" 
                                name="presentational_mode" 
                                value={formData.presentational_mode} 
                                onChange={handleChange}
                                required
                            >
                                <option value="in-attendance">In Attendance</option>
                                <option value="poster">Poster</option>
                                <option value="oral">Oral</option>
                            </select>
                        </div>
                    </div>
                </SymposiumSection>
            )}
        </Container>
    );
};

const SymposiumSection = styled.div`
    .symposium-section {
        margin-bottom: 1.5em;
        padding: 1em;
        border: 1px solid #ddd;
        border-radius: 6px;
        background-color: #f9f9f9;
    }
`;

const Container = styled.div`
    .file-upload-section {
        margin-bottom: 1.5em;
        
        .file-input-container {
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 0.8em;
            background: #f9f9f9;
            
            .file-input {
                margin-bottom: 0.5em;
                height: auto;
                padding: 0;
            }
            
            .file-format-note {
                display: block;
                font-size: 0.8em;
                color: #6a7285;
                margin-top: 0.3em;
            }
            
            .file-selected {
                display: flex;
                justify-content: space-between;
                align-items: center;
                
                .file-name {
                    font-size: 0.9em;
                    word-break: break-all;
                }
                
                
            }
        }
    }
`;

const Delete = styled.button`
    color: black;
    border: none;
    background-color: #f9f9f9;
    padding: 0.4em 0.8em;
    font-size: 0.8em;
    cursor: pointer;
    transition: background-color 0.2s;
    
    &:hover {
        color: #d10e34;
    }
`

export default AbstractSection;